export function getCommitLink(repositoryUrl: string, commitId: string | undefined): string | null {
    // This link generation is based off backend logic used for PR links in GitLinkProvider.cs
    // If there are any changes to commit link generation please check the backend logic for PR links as well.
    if (!commitId) {
        return null;
    }

    try {
        const parsedUrl = new URL(repositoryUrl);
        switch (parsedUrl.host) {
            case "github.com": {
                const baseUrl = getGitHubBaseUrl(parsedUrl);
                return baseUrl ? `${baseUrl}/commit/${commitId}` : null;
            }
            case "gitlab.com": {
                const baseUrl = getGitLabBaseUrl(parsedUrl);
                return baseUrl ? `${baseUrl}/-/commit/${commitId}` : null;
            }
            default:
                return null;
        }
    } catch {
        return null;
    }
}

function getPathParts(repositoryUrl: URL) {
    return repositoryUrl.pathname.split("/").filter((p) => p);
}

function getValidRepoName(repoName: string): string {
    return repoName.replace(/\.git$/, "");
}

function getGitHubBaseUrl(repositoryUrl: URL): string | null {
    const pathParts = getPathParts(repositoryUrl);
    // Expected format: https://github.com/<organisation>/<repo>
    if (pathParts.length < 2) {
        return null;
    }

    const user = pathParts[0];
    const repo = getValidRepoName(pathParts[1]);
    return `https://${repositoryUrl.host}/${user}/${repo}`;
}

function getGitLabBaseUrl(repositoryUrl: URL): string | null {
    const pathParts = getPathParts(repositoryUrl);
    // Expected format: https://gitlab.com/<organisation>[/subgroup[/subgroup[...]]]/<repo>
    if (pathParts.length < 2) {
        return null;
    }
    const repo = getValidRepoName(pathParts[pathParts.length - 1]);
    const organizationAndGroups = pathParts.slice(0, -1).join("/");
    return `https://${repositoryUrl.host}/${organizationAndGroups}/${repo}`;
}
